module.exports = __webpack_public_path__ + "img/user_share_null_logo.5c3fefe9.png";